/** Static ghost preview assets under public/assets/images/portfolio/empty/ */
export const PORTFOLIO_GHOST_EMPTY_ASSETS = {
  headerH5: "/assets/images/portfolio/empty/ghost-header-h5.webp",
  historyH5: "/assets/images/portfolio/empty/ghost-history-h5.webp",
  assetH5: "/assets/images/portfolio/empty/ghost-asset-h5.webp",
  chipsPc: "/assets/images/portfolio/empty/ghost-chips-pc.webp",
  statsPc: "/assets/images/portfolio/empty/ghost-stats-pc.webp",
  chartsPc: "/assets/images/portfolio/empty/ghost-charts-pc.webp",
} as const;

export const PORTFOLIO_GHOST_IMAGE_DIMENSIONS = {
  headerH5: { width: 361, height: 146 },
  historyH5: { width: 361, height: 364 },
  assetH5: { width: 361, height: 386 },
  chipsPc: { width: 768, height: 28 },
  statsPc: { width: 768, height: 86 },
  chartsPc: { width: 768, height: 250 },
} as const;
